import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import PageTemplate from '../PageTemplate';
import './PolicyCompliance.css';

const PolicyCompliance = () => {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = t('pages.policyCompliance.pageTitle');
  }, [t]);

  const breadcrumbs = [
    { labelKey: 'nav.services', href: '/#services' },
    { labelKey: 'services.policyCompliance' }
  ];

  return (
    <PageTemplate 
      titleKey="pages.policyCompliance.title"
      subtitleKey="pages.policyCompliance.subtitle"
      breadcrumbs={breadcrumbs}
    >
      <div className="page-content">
        {/* 顶部CTA区域 */}
        <div className="policy-compliance-cta-top">
          <a href="/connect-us" className="cta-button-primary">
            {t('pages.policyCompliance.cta')}
          </a>
        </div>

        {/* 服务价值定位 */}
        <div className="value-proposition-section">
          <div className="value-grid">
            <div className="value-card">
              <h3>{t('pages.policyCompliance.valueProposition.shield.title')}</h3>
              <p>{t('pages.policyCompliance.valueProposition.shield.desc')}</p>
            </div>
            <div className="value-card">
              <h3>{t('pages.policyCompliance.valueProposition.accelerator.title')}</h3>
              <p>{t('pages.policyCompliance.valueProposition.accelerator.desc')}</p>
            </div>
            <div className="value-card">
              <h3>{t('pages.policyCompliance.valueProposition.bridge.title')}</h3>
              <p>{t('pages.policyCompliance.valueProposition.bridge.desc')}</p>
            </div>
          </div>
        </div>

        {/* 为什么合规是核心竞争力 */}
        <div className="why-compliance-section">
          <h2>{t('pages.policyCompliance.whyCompliance.title')}</h2>
          <p className="highlight-text">
            {t('pages.policyCompliance.whyCompliance.mainTitle')}
          </p>
          <div className="benefits-list">
            <div className="benefit-item">
              <div className="benefit-content">
                <h4>{t('pages.policyCompliance.whyCompliance.benefit1.title')}</h4>
                <p>{t('pages.policyCompliance.whyCompliance.benefit1.desc')}</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-content">
                <h4>{t('pages.policyCompliance.whyCompliance.benefit2.title')}</h4>
                <p>{t('pages.policyCompliance.whyCompliance.benefit2.desc')}</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-content">
                <h4>{t('pages.policyCompliance.whyCompliance.benefit3.title')}</h4>
                <p>{t('pages.policyCompliance.whyCompliance.benefit3.desc')}</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-content">
                <h4>{t('pages.policyCompliance.whyCompliance.benefit4.title')}</h4>
                <p>{t('pages.policyCompliance.whyCompliance.benefit4.desc')}</p>
              </div>
            </div>
            <div className="benefit-item">
              <div className="benefit-content">
                <h4>{t('pages.policyCompliance.whyCompliance.benefit5.title')}</h4>
                <p>{t('pages.policyCompliance.whyCompliance.benefit5.desc')}</p>
              </div>
            </div>
          </div>
        </div>

        {/* 合规服务矩阵 */}
        <div className="services-matrix-section">
          <h2>{t('pages.policyCompliance.servicesMatrix.title')}</h2>
          <div className="matrix-grid">
            {/* 政策洞察类 */}
            <div className="matrix-category">
              <h3>{t('pages.policyCompliance.servicesMatrix.insights.title')}</h3>
              <div className="matrix-items">
                <div className="matrix-item">
                  <h4>{t('pages.policyCompliance.servicesMatrix.insights.item1.title')}</h4>
                  <p>{t('pages.policyCompliance.servicesMatrix.insights.item1.desc')}</p>
                </div>
                <div className="matrix-item">
                  <h4>{t('pages.policyCompliance.servicesMatrix.insights.item2.title')}</h4>
                  <p>{t('pages.policyCompliance.servicesMatrix.insights.item2.desc')}</p>
                </div>
                <div className="matrix-item">
                  <h4>{t('pages.policyCompliance.servicesMatrix.insights.item3.title')}</h4>
                  <p>{t('pages.policyCompliance.servicesMatrix.insights.item3.desc')}</p>
                </div>
              </div>
            </div>

            {/* 合规实施类 */}
            <div className="matrix-category">
              <h3>{t('pages.policyCompliance.servicesMatrix.implementation.title')}</h3>
              <div className="matrix-items">
                <div className="matrix-item">
                  <h4>{t('pages.policyCompliance.servicesMatrix.implementation.item1.title')}</h4>
                  <p>{t('pages.policyCompliance.servicesMatrix.implementation.item1.desc')}</p>
                </div>
                <div className="matrix-item">
                  <h4>{t('pages.policyCompliance.servicesMatrix.implementation.item2.title')}</h4>
                  <p>{t('pages.policyCompliance.servicesMatrix.implementation.item2.desc')}</p>
                </div>
                <div className="matrix-item">
                  <h4>{t('pages.policyCompliance.servicesMatrix.implementation.item3.title')}</h4>
                  <p>{t('pages.policyCompliance.servicesMatrix.implementation.item3.desc')}</p>
                </div>
              </div>
            </div>

            {/* 风险管控类 */}
            <div className="matrix-category">
              <h3>{t('pages.policyCompliance.servicesMatrix.riskControl.title')}</h3>
              <div className="matrix-items">
                <div className="matrix-item">
                  <h4>{t('pages.policyCompliance.servicesMatrix.riskControl.item1.title')}</h4>
                  <p>{t('pages.policyCompliance.servicesMatrix.riskControl.item1.desc')}</p>
                </div>
                <div className="matrix-item">
                  <h4>{t('pages.policyCompliance.servicesMatrix.riskControl.item2.title')}</h4>
                  <p>{t('pages.policyCompliance.servicesMatrix.riskControl.item2.desc')}</p>
                </div>
                <div className="matrix-item">
                  <h4>{t('pages.policyCompliance.servicesMatrix.riskControl.item3.title')}</h4>
                  <p>{t('pages.policyCompliance.servicesMatrix.riskControl.item3.desc')}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* 专业领域覆盖 */}
        <div className="coverage-section">
          <h2>{t('pages.policyCompliance.coverage.title')}</h2>
          <div className="coverage-tags">
            <span className="coverage-tag">{t('pages.policyCompliance.coverage.area1')}</span>
            <span className="coverage-tag">{t('pages.policyCompliance.coverage.area2')}</span>
            <span className="coverage-tag">{t('pages.policyCompliance.coverage.area3')}</span>
            <span className="coverage-tag">{t('pages.policyCompliance.coverage.area4')}</span>
            <span className="coverage-tag">{t('pages.policyCompliance.coverage.area5')}</span>
            <span className="coverage-tag">{t('pages.policyCompliance.coverage.area6')}</span>
            <span className="coverage-tag">{t('pages.policyCompliance.coverage.area7')}</span>
            <span className="coverage-tag">{t('pages.policyCompliance.coverage.area8')}</span>
          </div>
        </div>

        {/* 差异化优势 */}
        <div className="advantages-section">
          <h2>{t('pages.policyCompliance.advantages.title')}</h2>
          <div className="advantages-grid">
            <div className="advantage-card">
              <h3>{t('pages.policyCompliance.advantages.item1.title')}</h3>
              <p>{t('pages.policyCompliance.advantages.item1.desc')}</p>
            </div>
            <div className="advantage-card">
              <h3>{t('pages.policyCompliance.advantages.item2.title')}</h3>
              <p>{t('pages.policyCompliance.advantages.item2.desc')}</p>
            </div>
            <div className="advantage-card">
              <h3>{t('pages.policyCompliance.advantages.item3.title')}</h3>
              <p>{t('pages.policyCompliance.advantages.item3.desc')}</p>
            </div>
            <div className="advantage-card">
              <h3>{t('pages.policyCompliance.advantages.item4.title')}</h3>
              <p>{t('pages.policyCompliance.advantages.item4.desc')}</p>
            </div>
            <div className="advantage-card">
              <h3>{t('pages.policyCompliance.advantages.item5.title')}</h3>
              <p>{t('pages.policyCompliance.advantages.item5.desc')}</p>
            </div>
          </div>
        </div>

        {/* 成功指标展示 */}
        <div className="stats-section">
          <h2>{t('pages.policyCompliance.stats.title')}</h2>
          <div className="stats-grid-modern">
            <div className="stat-card">
              <div className="stat-number">500+</div>
              <div className="stat-label">{t('pages.policyCompliance.stats.projects')}</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">100%</div>
              <div className="stat-label">{t('pages.policyCompliance.stats.compliance')}</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">20+</div>
              <div className="stat-label">{t('pages.policyCompliance.stats.experts')}</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">15</div>
              <div className="stat-label">{t('pages.policyCompliance.stats.countries')}</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">99%</div>
              <div className="stat-label">{t('pages.policyCompliance.stats.satisfaction')}</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">48h</div>
              <div className="stat-label">{t('pages.policyCompliance.stats.response')}</div>
            </div>
          </div>
        </div>

        {/* 客户见证 */}
        <div className="testimonial-section">
          <div className="testimonial-card">
            <p className="testimonial-text">
              "{t('pages.policyCompliance.testimonial.text')}"
            </p>
            <p className="testimonial-author">
              {t('pages.policyCompliance.testimonial.author')}
            </p>
          </div>
        </div>

        {/* 最终行动召唤 */}
        <div className="final-cta-section">
          <h2>{t('pages.policyCompliance.callToAction.title')}</h2>
          <p>{t('pages.policyCompliance.callToAction.subtitle')}</p>
          <a href="/connect-us" className="cta-button-large">
            {t('pages.policyCompliance.callToAction.button')}
          </a>
          <p className="cta-note">{t('pages.policyCompliance.callToAction.note')}</p>
        </div>
      </div>
    </PageTemplate>
  );
};

export default PolicyCompliance;
